export default __webpack_public_path__ + "static/media/default.85a68d1b70a5f2ac3dbf6a73a84046df.svg";